import { trpc } from "@/utils/trpc";
import { useQuery } from "@tanstack/react-query";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import { useMemo } from "react";
import { Image } from "@tiptap/extension-image";

type AssetRef = { channelId: number; bucket: string; key: string };

function parseAssetsSrc(src?: string): AssetRef | null {
    if (!src) return null;
    if (!src.startsWith("assets://")) return null;

    const rest = src.slice("assets://".length);
    const firstSlash = rest.indexOf("/");
    if (firstSlash === -1) return null;

    const bucket = rest.slice(0, firstSlash);
    const key = rest.slice(firstSlash + 1);

    const m = key.match(/^channels\/(\d+)\//);
    if (!m) return null;

    return { channelId: Number(m[1]), bucket, key };
}

const AssetImageView: React.FC<any> = ({ node }) => {
    const src = node.attrs.src as string | undefined;

    const asset = useMemo(() => parseAssetsSrc(src), [src]);

    const { data } = useQuery({
        ...trpc.doc.getPresignedImageDownloadUrl.queryOptions(
          asset ?? { channelId: 0, bucket: "", key: "" },
        ),
        enabled: !!asset,
        staleTime: 4 * 60 * 1000,
        refetchOnWindowFocus: true,
    });

    const realSrc = asset ? data?.url : src;

    return (
        <NodeViewWrapper as="span">
            {realSrc ? (
                <img
                    src={realSrc}
                    alt={node.attrs.alt ?? ""}
                    title={node.attrs.title ?? ""}
                    draggable={node.attrs.draggable ?? true}
                />
            ) : (
                <span className="text-muted-foreground text-sm">Loading image…</span>
            )}
        </NodeViewWrapper>
    )
}

export const AssetImage = Image.extend({
    addNodeView() {
      return ReactNodeViewRenderer(AssetImageView);
    },
  });